// extracted by mini-css-extract-plugin
export default {"root":"ChatView_root__GXWW1"};